import { CarouselImageModel } from '../models/carousel-image';

export class CarouselImageAdapter {
  static fromApi(response: any): CarouselImageModel {
    const data = response.data || response;

    return {
      id: data.id,
      title: data.title,
      description: data.description,
      imagePath: data.imagePath,
      order: data.order,
      active: data.active,
      creationDate: data.creationDate,
      updateDate: data.updateDate,
      userNameCreate: data.userNameCreate,
      userNameUpdate: data.userNameUpdate,
    };
  }

  static fromApiArray(response: any): CarouselImageModel[] {
    const dataArray = response.data || response;

    if (!Array.isArray(dataArray)) {
      return [];
    }

    return dataArray
      .map((item: any) => this.fromApi({ data: item }))
      .sort((a, b) => a.order - b.order);
  }
}
